module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/219-isle-of-man-dda61b81bc473714b485f01fe57d22c9.svg";